import React from 'react';
import { JobsList } from './JobsList';

export const JobsLists = () => {
    return (
        <div>
            <JobsList />
        </div>
    );
};
